import { inject, Injectable } from '@angular/core';
import { BrowserControlService } from '../../../cross-team-shared/misc-services/browser-control.service';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { WorkspaceLoadingService } from '../../../shared/misc-services/workspace-loading.service';
import { DebounceSaveManagerService } from '../../../shared/save-manager/debounce-save-manager.service';
import { SampleTask } from '../../../team-apis/otterdam/sample-task';
import { SamplingWorkspaceStore } from '../state/sampling-workspace-store';

@Injectable()
export class SampleTaskNavigationService {
  private workspaceLoadingService = inject(WorkspaceLoadingService);
  private debounceSaveManager = inject(DebounceSaveManagerService<SampleTask>);
  private eventTrackingService = inject(EventTrackingService);
  private browserControlService = inject(BrowserControlService);
  private positionStore = inject(SamplingWorkspaceStore)('position');

  navigateTo(
    offset: number,
    source: string,
    pagePosition?: 'header' | 'footer',
  ) {
    this.navigateToTask(
      this.positionStore.state() + offset,
      source,
      pagePosition,
    );
  }

  navigateToTask(
    position: number,
    source: string,
    pagePosition?: 'header' | 'footer',
  ) {
    this.positionStore.set(position);
    this.updateQueryParam();
    this.debounceSaveManager.saveAndThen(() => {
      this.eventTrackingService.track({
        id: 'navigate_in_sample',
        bucket: 'untracked',
        source,
        page_position: pagePosition,
      });
      return this.workspaceLoadingService.resetWorkspace();
    });
  }

  private updateQueryParam() {
    this.browserControlService.updateQueryParameters([
      'position',
      this.positionStore.state().toString(),
    ]);
  }
}
